import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'media-upload-dialog',
  template: `
    <div class="header">
      <div class="title-wrap">
        <div class="title">Add media</div>
        <div class="subtitle">Drop an image or pick a file from your device.</div>
      </div>
      <button mat-icon-button aria-label="Close add media dialog" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="body">
      <media-upload (imageUploaded)="imageUploaded($event)"></media-upload>
    </div>
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }

    .header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      margin: 0 12px;
      padding: 10px 0;
      border-bottom: 1px solid #e5e9f0;
    }

    .title-wrap {
      min-width: 0;
    }

    .title {
      color: #111827;
      font-size: 20px;
      font-weight: 700;
      line-height: 1.2;
    }

    .subtitle {
      margin-top: 4px;
      color: #64748b;
      font-size: 13px;
    }

    .body {
      padding: 12px;
    }
  `,
})
export class MediaUploadDialog {
  constructor(private dialogRef: MatDialogRef<MediaUploadDialog>) {}

  close() {
    this.dialogRef.close();
  }

  imageUploaded(imageId: string) {
    this.dialogRef.close(imageId);
  }
}
